import React, {useState} from 'react';

const Countdown = () => {
  const weddingDate = new Date('2025-05-03T15:00:00');
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = +new Date(weddingDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }

    return timeLeft;
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return (
    <div className="countdown__time-countdown">
      <div className="countdown__time-countdown-item">
        <div className="countdown__time-countdown-item__number">{timeLeft.days}</div>
        <div>Días</div>
      </div>
      <div className="countdown__time-countdown-item">
        <div className="countdown__time-countdown-item__number">{timeLeft.hours}</div>
        <div>Horas</div>
      </div>
      <div className="countdown__time-countdown-item">
        <div className="countdown__time-countdown-item__number">{timeLeft.minutes}</div>
        <div>Minutos</div>
      </div>
      <div className="countdown__time-countdown-item">
        <div className="countdown__time-countdown-item__number">{timeLeft.seconds}</div>
        <div>Segundos</div>
      </div>
    </div>
  );
};


export default Countdown;
